import { call, put, takeEvery } from 'redux-saga/effects';
import { searchBikeBrand } from '../../requests/search_bikes_by_params';
import { searchBikeBrandSuccess, searchBikeBrandFailure } from '../actions/search_bikes.actions';
import { SEARCH_BIKE_BRAND_REQUEST } from '../constants/search_bikes.constants';

function* searchBikeBrandRequest({ searchText }) {
    const response = yield call(searchBikeBrand, searchText);
    if (response.result) {
        yield put(searchBikeBrandSuccess(response.options));
    } else {
        yield put(searchBikeBrandFailure(response.error));
    }
}

export default function* searchBikeBrandSaga() {
    yield takeEvery(SEARCH_BIKE_BRAND_REQUEST, searchBikeBrandRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_bike_brand.saga.js